import * as React from "react";
import cn from "clsx";
import { FaIcon } from "./faIcon";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { InIcon } from "./inIcon";

export type IconProps = {
  prefix: "inno" | "fasr" | "fass";
  iconName: string;
  size?: "xs" | "s" | "m" | "l" | "xl" | "2xl" | "3xl";
  shape?:
    | "square"
    | "circle"
    | "dome-narrow"
    | "half-moon-left-wide"
    | "half-moon-right-wide"
    | "drop";
} & React.HTMLAttributes<HTMLDivElement>;

const Icon = React.forwardRef<HTMLDivElement, IconProps>(
  (
    {
      className,
      role = "icon",
      size,
      prefix = "inno",
      iconName,
      children,
      style,
      shape,
      ...props
    },
    ref
  ) => {
    return (
      <span className={cn("in-icon", shape ? `in-icon--${size}--${shape}` : `in-icon--${size}`, className)}>
        {prefix === "inno" ? (
          <InIcon size={size} iconName={iconName} />
        ) : (
          <FaIcon size={size} prefix={prefix} iconName={iconName}></FaIcon>
        )}
      </span>
    );
  }
);
Icon.displayName = "Icon";

export { Icon };
